// extracted by mini-css-extract-plugin
export default {"root":"BatchDetailsTable_root__t4rVr"};